import React from "react";
import { BrowserRouter, useLocation } from "react-router-dom";
import AppRoutes from "./routes/AppRoutes.js";
import Sidebar from "./components/Sidebar.js";
import Navbar from "./components/Navbar.js";

console.log("✅ App.js loaded — starting React App");

const Layout = () => {
  const location = useLocation();

  // Paths where Sidebar should be hidden
  const hideSidebarPaths = ["/", "/employee-login"];

  const shouldHideSidebar = hideSidebarPaths.includes(location.pathname);

  return (
    <div className="flex h-screen bg-gray-100">
      {!shouldHideSidebar && <Sidebar />}
      <div className="flex flex-col flex-1">
        <Navbar />
        <div className="p-6">
          <AppRoutes />
        </div>
      </div>
    </div>
  );
};

const App = () => (
  <BrowserRouter>
    <Layout />
  </BrowserRouter>
);

export default App;
